var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_27274_244553",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 24.5796C48 37.7576 37.2548 48.4405 24 48.4405C10.7452 48.4405 0 37.7576 0 24.5796C0 11.4016 10.7452 0.71875 24 0.71875C37.2548 0.71875 48 11.4016 48 24.5796Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24.5796C48 37.7576 37.2548 48.4405 24 48.4405C10.7452 48.4405 0 37.7576 0 24.5796C0 11.4016 10.7452 0.71875 24 0.71875C37.2548 0.71875 48 11.4016 48 24.5796Z",
    fill: "#FDF4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24.5796C47 37.1999 36.708 47.4405 24 47.4405V49.4405C37.8016 49.4405 49 38.3154 49 24.5796H47ZM24 47.4405C11.292 47.4405 1 37.1999 1 24.5796H-1C-1 38.3154 10.1984 49.4405 24 49.4405V47.4405ZM1 24.5796C1 11.9594 11.292 1.71875 24 1.71875V-0.28125C10.1984 -0.28125 -1 10.8439 -1 24.5796H1ZM24 1.71875C36.708 1.71875 47 11.9594 47 24.5796H49C49 10.8439 37.8016 -0.28125 24 -0.28125V1.71875Z",
    fill: "#DA2F58",
    mask: "url(#path-1-inside-1_27274_244553)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7636 15.6328H22.2455L22.5364 28.8283H25.4636L25.7636 15.6328ZM24 34.5227C25.0727 34.5227 25.9909 33.6284 26 32.515C25.9909 31.42 25.0727 30.5257 24 30.5257C22.891 30.5257 21.991 31.42 22.0001 32.515C21.991 33.6284 22.891 34.5227 24 34.5227Z",
    fill: "#DA2F58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.b968ec67.svg";
export { ForwardRef as ReactComponent };